import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

// Styling
import styles from './styles';

// Actions
import { SetMarkSpot } from './actions';


class MarkSpot extends Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired
  };

  onMarkSpot() {

    if (window.location.href.includes("filters?name=") || window.location.href.includes("results") || window.location.href.includes("question") || window.location.href.includes("adhoc_filters/")){
        alert("The MarkSpot & Resume featured cannot be used from this section of the site for now. It will be installed later in the Beta")
    } else {
      SetMarkSpot("window.location.href");

      // Cookies
      const { cookies } = this.props;

      let date = new Date();
      date.setTime(date.getTime()+(7*24*60*60*1000));

      cookies.set('last_href', window.location.href, { path: '/', expires: date });
      this.props.changeRoute("/");
    }
  }

  render(){
    const { classes } = this.props;
    return(
      <Button className={classes.root} onClick={() => {this.onMarkSpot()}}>
          Resume & Mark Spot
      </Button>
    );
  }
}

MarkSpot.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        counter: state.counter,
        router: state.router,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
    markSpot: SetMarkSpot,
  }
}

export default withCookies(withStyles(styles, { withTheme: true })(connect(mapStateToProps,mapDispatchToProps)(MarkSpot)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ApplicationBar/components/ToolBar/components/MarkSpot/index.js